export const viewTypeOptions = {
  LIST_VIEW: 'list',
  TILE_VIEW: 'tiles'
}

export const projectListTabOption = {
  MY_PROJECTS: 'my-projects',
  COMPANY_PROJECTS: 'company-projects'
}
